const { db } = require("common/config/Firebase")

const collectionParams = db.collection('params')

const findColumnsOrderUseCase = async ({ doc }) => {
    const paramsData = await collectionParams.doc(doc).get()
    const { columnsOrder } = paramsData.data()

    return columnsOrder
}

export default findColumnsOrderUseCase